import * as React from 'react'
import * as Redux from 'redux'
import Radium, { StyleRoot } from 'radium'
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {CampusFooter} from '../Components/CampusFooter'
import {CampusUploadFiles} from '../UploadFiles/CampusUploadFiles'
import {CampusRevisionNotes} from './CampusRevisionNotes'
import {browserHistory} from 'react-router'
import {CampusHeader} from '../Components/CampusHeader'
import {CampusFeedback} from '../FlatPages/CampusFeedback'
import * as Request from '../tgccRequest'

const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width:'100%',
    height:'auto',
}

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: '25px',
}

const woStyle: React.CSSProperties = {
    fontSize: '22px',
    letterSpacing: '6px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    fontFamily:'BarlowMedium',
    color: 'rgba(88,88,88,0.8)',
    marginTop:'20px',
    '@media (max-width:320px)': {
        fontSize:'36px'
    }
}

const statusStyle: React.CSSProperties = {
    fontSize: '18px',
    letterSpacing: '2px',
    fontWeight: 100,
    textTransform: 'uppercase',
    marginBottom: '10px',
    fontFamily:'BarlowMedium',
    color: 'rgba(88,88,88,0.7)',
    '@media(max-width:414px)': {
        fontSize:'16px'
    },
    '@media(max-width:375px)': {
        fontSize:'15px'
    },
    '@media(max-width:320px)': {
        fontSize:'12px'
    }
    
}
const imgStyle: React.CSSProperties = {
    alignSelf: 'center',
    width: 'auto',
    height: 'auto',
    maxHeight: '400px',
}

const btnStyle: React.CSSProperties = {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: 'rgb(103,186,175)',
    padding: '5px 40px',
    marginTop: '5px',
    marginBottom: '10px'
};

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#686868'
}
const createAcc: React.CSSProperties = {
    textAlign:'center',
}
const container: React.CSSProperties = {
    backgroundColor:'#E9E6E6',
    width:'725px',
    margin:'auto',
    borderRadius:'20px',
    textAlign:'center'
}
const statStyle: React.CSSProperties = {
    color:'#E27558'
}
const imgCont: React.CSSProperties = {
    backgroundColor:'white',
    width:'427px',
    height:'488px',
    borderRadius:'20px',
    margin:'auto',
    padding:'10px',
}

const bottomCont: React.CSSProperties = {
    backgroundColor:'white',
    width:'482px',
    borderRadius:'20px',
    padding:'10px',
    margin:'40px auto',
}
const notLoggedIn: React.CSSProperties = {
    textAlign:'center',
    fontSize:'20px',
    fontFamily:'BarlowLight',
    position:'absolute',
    top:'0px',
    left:'50%',
    width: '500px',
    height:'50px',
    marginLeft:'-250px',
    zIndex:2,
    lineHeight:'48px',
    backgroundColor:'#E9E6E6',
    borderBottomLeftRadius:'15px',
    borderBottomRightRadius:'15px'
}
 
let errorStyle = Object.assign({},Tgcc.Styles.error, {fontSize: '20px'});

class _CampusProofRevise extends React.Component<Tgcc.BaseProps, any>{
    state = { 
        proof: null,
        uploadedFiles: {},
        notes: null,
        error: null,
        isWaiting: true
    };

    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            Request.getProof(login, proofId, this.proofLoaded, this.loadError);
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }

    componentDidMount(){
        var tag = document.getElementById('proofRevise');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }

    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof, isWaiting: false});
    }

    loadError = (err: any) => {
        this.setState({isWaiting: false});
        console.log("error loading proof: ", err);
        Tgcc.promptForLogin(this.props.dispatch);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    canReviseProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'ARTWORK':
                case 'CHANGES':
                case 'EMAILED':
                case 'MISSING':
                case 'M-PROOF':
                case 'PENDING':
                case 'REVIEW':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    addUploadToProof = (key: string, fileUrl: string) => {
        var newFile = {};
        newFile[key] = fileUrl;
        this.setState({uploadedFiles: Object.assign( {}, this.state.uploadedFiles, newFile), isWaiting: false, error: null});
    }

    removeUploadFromProof = (fileUrl: string) => {
        var files = this.state.uploadedFiles;
        var newfiles = {};
        Object.keys(files).map( (key) => {
            if(files[key] != fileUrl)
                newfiles[key] = files[key];
        });
        this.setState({uploadedFiles: newfiles});
        Request.deleteUpload(this.state.proof.proofId, fileUrl);
    }

    revisionNotesChanged = (notes: string) => {
        this.setState({notes: notes, isWaiting: false, error: null});
    }

    getUploadedUrls = () => {
        var files = new Array();
        for( var prop in this.state.uploadedFiles){
            files.push(this.state.uploadedFiles[prop]);
        }
        return files;
    }

    saveRevision = () => {
        var login = this.props.state.LoginData;
        var proofId = this.state.proof.proofId;
        var notes = this.state.notes;
        var uploads: string[] = this.getUploadedUrls();

        if(notes || uploads.length){
            this.setState({error: null, isWaiting: true});
            Request.reviseProof(login, proofId, notes, uploads, this.revisionSuccessful, this.revisionFailed);
        } else {
            this.setState({error: "Nothing to save"});
        }
    }

    revisionSuccessful = () => {
        browserHistory.replace(Tgcc.Routes.CampusDashboard);
    }

    revisionFailed = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }

    cancel = () => {
        browserHistory.push(Tgcc.Routes.CampusDashboard);
    }
    getDashHeader(){
        return (
            <div style={createAcc} className="createAcct">
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>PROOF REVISION</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }
    notLoggedin () {
        if(!this.props.state.LoginData){
            return (
                <div>
                    <div style={notLoggedIn} className='pVNotLoggedIn'>Please log in to view your proof.</div>
                </div>
            )}
    }

    render(){
        var error = this.state.error ? <div style={errorStyle}>{this.state.error}</div> : null;
        var proof: Tgcc.Proof = this.state.proof || new Tgcc.Proof;
        var revisionElements = <div style={statusStyle}>Order of status {proof.status} cannot be revised.</div>;
        var imgPath = proof? Tgcc.getProofPath(proof.proofId) : Tgcc.Styles.missingProofImageSrc;
        if(this.canReviseProof(proof)) {
            revisionElements = (
                <div style={contentStyle} className="campusReviseImg">
                  <div style={imgCont} className="campusRevisePImg">
                   <img style={imgStyle} src={imgPath} onError={this.onError} className="campusReviseBoxes"/>
                   </div>
                   <div style={bottomCont} className="bottomReviseCont">
                     {error}
                     <div className='campusUploadDiv'>
                        <CampusUploadFiles proofId={proof.proofId} uploadedFiles={proof.uploadedFiles} title="Upload new artwork" addUpload={this.addUploadToProof} removeUpload={this.removeUploadFromProof}/>
                    </div>
                    <CampusRevisionNotes onChange={this.revisionNotesChanged} saveRevision={this.saveRevision} cancelRevision={this.cancel}/>
                  </div>
                </div>
            );
        } else {
            revisionElements = (
                <div style={contentStyle} className="campusReviseImg">
                   <img style={imgStyle} className='campusRevisePImg' src={imgPath} onError={this.onError} />
                   {error}
                </div>
            );
        }
        var waiting = this.state.isWaiting ? Tgcc.workingGif : null;
        return (
            <div style={wrapperStyle}>
            {this.notLoggedin()}
            <div id='campusRevise'></div>
            <CampusHeader />
            <CampusFeedback state={this.props.state} />
                <div id="proofRevise"></div>
                {this.getDashHeader()}
                <div style={container} className='campusReviseBox'>
                    <div style={woStyle}>{proof.proofId}</div>
                    <div style={statusStyle}>Order Status:  <span style={statStyle}>{proof.status}</span></div>
                    {waiting}
                    {revisionElements}
                </div>
                <div className="campusRevisionFoot">
                <CampusFooter state={this.props.state}/>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var CampusProofRevise = connect(mapStateToProps)(Radium(_CampusProofRevise));